import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";
import {IErrors} from "@/model/IErrors";
import {IScreensaverLog, IScreensaverLog as ILockerCompanyLog} from "@/model/logs/Ilogs"; // @todo fix later
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/RootState";
import responseHandler from "@/plugins/errorHandling";
import axios from "axios";
import {settings} from "@/plugins/settings";


interface LockerCompanyState {
  lockerCompanies: ILockerCompany[];
  lockersLockerCompanies: ILockerCompany[];
  logs: ILockerCompanyLog[];
  errors: IErrors;
}

const state: LockerCompanyState = {
  lockerCompanies: [],
  lockersLockerCompanies: [],
  logs: [], // @todo
  errors: {},
};

const getters: GetterTree<LockerCompanyState, RootState> = {
  lockerCompanies: (state: LockerCompanyState): ILockerCompany[] => state.lockerCompanies,
  lockersLockerCompanies: (state: LockerCompanyState): ILockerCompany[] => state.lockersLockerCompanies,
  logs: (state): ILockerCompanyLog[] => state.logs,
  errors: (state) => state.errors,
}

const actions: ActionTree<LockerCompanyState, RootState> = {

  fetchLockerCompanies: ({ commit }, filters: any): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockerCompanies',
      method: "GET",
      params: {
        ...filters,
      },
    }),
    commit,
    'lockerCompaniesLoaded'
  ),

  clearLockerCompanies: ({commit}):any => commit('clearLockerCompanies'),

  createLockerCompany: ({ commit }, {slug,  description}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockerCompanies',
      method: "POST",
      data: {
        slug,
        description,
      },
    }),
    commit,
    'lockerCompanyCreated'
  ),

  fetchLockersLockerCompanies: ({commit}: any, lockerId: number): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + `lockers/${lockerId}/lockerCompanies`,
      method: 'GET'
    }),
    commit,
    'lockersLockerCompaniesLoaded'
  ),

  fetchLogs: ({commit}: any, filters: any): any => responseHandler.handle(
    () => axios({
      url: `${settings.endpoint}lockerCompanies/logs`,
      method: 'GET',
      params: {
        ...filters,
      },
    }),
    commit,
    'lockerCompanyLogsLoaded'
  ),

  connectLockerCompany: ({commit}, {lockerCompanyId, lockerId, connect}): any => {
    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'lockerCompanies/' + lockerCompanyId + '/lockers/' + lockerId,
        method: connect ? 'PUT' : 'DELETE',
      }),
      commit,
      'lockersLockerCompaniesLoaded',
      null,
      false
    )
  },

  clearLogs:  ({commit}): any => {
    commit('clearLogs');
  },

  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },

  cleanErrors: ({commit}): any => {
    commit('errors', []);
  }

}

const mutations: MutationTree<LockerCompanyState> = {
  lockerCompaniesLoaded(state, payload: ILockerCompany[]) {
    state.lockerCompanies = payload;
  },

  lockersLockerCompaniesLoaded(state, payload: ILockerCompany[]) {
    state.lockersLockerCompanies = payload;
  },

  clearLockerCompanies(state) {
    state.lockerCompanies = [];
  },

  lockerCompanyCreated(state, payload: ILockerCompany) {
    state.lockerCompanies = state.lockerCompanies.concat(payload);
  },

  lockerCompanyLogsLoaded(state, payload: IScreensaverLog) {
    state.logs = state.logs.concat(payload);
  },

  clearLogs(state) {
    state.logs = [];
  },

  errors(state, payload: IErrors) {
    state.errors = payload;
  },

}

const namespaced: boolean = true;

export const lockerCompanyModule: Module<LockerCompanyState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
